export const MINIMUM_LOAN_AMOUNT = 1000;
export const MIN_LOAN_FOR_PORTAL_WITH_SMALL_LOAN_PROGRAM = 3000;
export const MIN_LOAN_FOR_PORTAL = 15000;
export const MAX_LOAN_FOR_PORTAL = 500000;
export const INVALID_PHONE_LINE_TYPE = 'Please Enter a Unique Mobile Phone Number';
